import { useSelector, useDispatch } from 'react-redux';
import { authActions } from '_store';
import { HEULIEZ_Logo_White, IVECO_BUS_Logo_WHITE_web } from 'assets/img/partnersLogo';
import { getIcons } from '_helpers';
import { HeaderButton } from './buttons';
import { NavLink, useNavigate } from 'react-router-dom';

export { Nav };

function Nav() {
    const auth = useSelector(x => x.auth.value);
    const dispatch = useDispatch();
    const logout = () => dispatch(authActions.logout());
    const navigate = useNavigate();


    const headerBtns = [        
        {
            name: "Données",
            pathTo: "/donnees",
            roles: ["user_portal", "admin"]
        },
        {
            name: "Alertes",
            pathTo: "/alertes",
            roles: ["user_portal", "admin"],
            subLinks: [
                { name: "Rapport", pathTo: "/alertes" },
                { name: "Gestion", pathTo: "/alertes/gestion" }
            ]
        },
        {
            name: "Filtres",
            pathTo: "/filtres",
            roles: ["user_portal", "admin"]
        },
        {
            name: "Diag Logger",
            pathTo: "/diagnostic",
            roles: ["user_portal", "admin"]
        },
        {
            name: "Géolocalisation",
            pathTo: "/geolocalisation",
            roles: ["user_geolocalisation", "user_portal", "admin"]
        },
        {
            name: "Gestion des Utilisateurs",
            pathTo: "/utilisateurs",
            roles: ["admin"]
        },
        {
            name: "Mon compte",
            pathTo: `utilisateur/${auth?.username}`,
            roles: ["admin", "user_geolocalisation", "user_portal"]
        },
    ]

    // only show nav when logged in
    if (!auth) return null;
    
    return (
        <nav className="navbar navbar-expand navbar-dark bg-global-blue px-3">  
            <div className="nav-icon-container">
                <button onClick={() => navigate('/')}><img src={IVECO_BUS_Logo_WHITE_web} alt="Logo Iveco" className="nav-icon bordered-icon" /></button>
                <button onClick={() => navigate('/')}><img src={HEULIEZ_Logo_White} alt="Logo Heuliez" className="nav-icon-small" /></button>        
            </div>          
            <div className='nav-title'>
                <button onClick={() => navigate('/')}>
                    Portail Bus Elec
                </button>    
            </div>
            <div className="navbar-nav"> 
                {headerBtns.map((header) => (
                    header.roles.includes(auth?.role) && (
                        header.name === "Alertes" ? (
                            <div key={header.name} className="nav-item dropdown">
                                <NavLink className={`nav-item nav-link header-button px-3`} to={header.pathTo}>
                                    {header.name}
                                    <div className="relative">
                                        <div className="header-circle-selector">
                                            <img src={getIcons("headerCircle")} alt="circle"/>
                                        </div>
                                    </div>
                                </NavLink>
                                <div className="dropdown-menu nav-submenu bg-global-blue">
                                    {header.subLinks.map((subLink) => (
                                        <NavLink
                                            key={subLink.name} 
                                            className={`nav-item nav-link header-button px-3 `} 
                                            to={subLink.pathTo}
                                        >
                                            {subLink.name}                                            
                                        </NavLink>
                                    ))}
                                </div>
                            </div>
                        ) : (
                            <HeaderButton info={header} key={header.name} />
                        )
                    )
                ))}     
                {/*headerBtns.map((header) => (
                    header.roles.indexOf(auth?.role) !== -1 && 
                        <HeaderButton info={header} key={header.name}/>
                    )
                )*/}               
            </div>
            <button onClick={logout} className="btn btn-link nav-item nav-btn nav-link">
                <img src={getIcons('logoutOutlined')} alt='logout' title='Déconnexion' />
            </button>
        </nav>
    );
}